export default {"src":"/_next/static/media/element-icon.b27fdfe4.svg","height":74,"width":66};